import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .MuiBox-root {\n    width: 100%;\n  }\n  .MuiPaper-root {\n    overflow: hidden;\n\n    @media (max-width: 1200px) {\n      width: 400px;\n    }\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  max-height: calc(100vh - 48px);\n  padding: 28px 20px 0 20px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px; /* 150% */\n\n  margin-bottom: 8px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Drawer } from "@mui/material";
import styled from "styled-components";
const AnchorDrawer = (param)=>{
    let { open , onClose , anchor ="bottom" , children , ...props } = param;
    return /*#__PURE__*/ _jsx(DrawerBox, {
        anchor: anchor,
        open: open,
        onClose: onClose,
        transitionDuration: {
            enter: 500,
            exit: 400
        },
        sx: anchor === "bottom" ? {
            ".MuiPaper-root": {
                borderRadius: "12px 12px 0 0"
            },
            maxHeight: "calc(100vh - 48px)"
        } : {},
        ...props,
        children: /*#__PURE__*/ _jsx(Box, {
            sx: {
                width: anchor === "bottom" || anchor === "top" ? "100%" : "250px"
            },
            children: children
        })
    });
};
const Contents = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(BottomBox, {
        children: children
    });
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(TitleText, {
        children: children
    });
};
AnchorDrawer.Contents = Contents;
AnchorDrawer.Title = Title;
export const DrawerBox = styled(Drawer).withConfig({
    componentId: "sc-76dc330b-0"
})(_templateObject());
const BottomBox = styled.div.withConfig({
    componentId: "sc-76dc330b-1"
})(_templateObject1());
const TitleText = styled.p.withConfig({
    componentId: "sc-76dc330b-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_900);
export default AnchorDrawer;
